export default __webpack_public_path__ + "static/media/themelogo.e2050902.png";